var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb'),_c('br'),_c('v-card',[_c('surveys-list',{attrs:{"surveys":_vm.getSurveys}}),(_vm.getSurveys.length <= 0)?_c('h3',{staticClass:"text-xs-center",attrs:{"display-2":"","pa-20":""}},[_vm._v("No hay encuestas")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }